import { Injectable } from '@angular/core';

import { FormlyFieldConfig } from '@ngx-formly/core';

import { ConfigDataParser, NavTabPath, PagePath, QuestionPath, SectionPath } from '../helpers/config-data-parser';

@Injectable({
  providedIn: 'root'
})
export class FormConfigurationParserService {

  findNavTabConfigs = (formConfig: FormlyFieldConfig[]): FormlyFieldConfig[] =>
    ConfigDataParser.getNavTabConfigs(formConfig);

  findNavTabConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number): FormlyFieldConfig =>
    ConfigDataParser.getNavTabConfig(formConfig, [navTabNumber]);

  findPageConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number): FormlyFieldConfig[] =>
    ConfigDataParser.getPageConfigs(formConfig, [navTabNumber]);

  findPageConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number): FormlyFieldConfig =>
    ConfigDataParser.getPageConfig(formConfig, [navTabNumber, pageNumber]);

  findSectionConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number): FormlyFieldConfig[] =>
    ConfigDataParser.getSectionConfigs(formConfig, [navTabNumber, pageNumber]);

  findSectionConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string): FormlyFieldConfig =>
    ConfigDataParser.getSectionConfig(formConfig, [navTabNumber, pageNumber, sectionCode]);

  findQuestionConfigs = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string): FormlyFieldConfig[] =>
    ConfigDataParser.getQuestionConfigs(formConfig, [navTabNumber, pageNumber, sectionCode]);

  findQuestionConfig = (formConfig: FormlyFieldConfig[], navTabNumber: number, pageNumber: number, sectionCode: string, questionCode: string): FormlyFieldConfig =>
    ConfigDataParser.getQuestionConfig(formConfig, [navTabNumber, pageNumber, sectionCode, questionCode]);

  getNavTabPaths = (formConfig: FormlyFieldConfig[]): NavTabPath[] =>
    ConfigDataParser.getNavTabPaths(formConfig);

  getPagePaths = (formConfig: FormlyFieldConfig[]): PagePath[] =>
    ConfigDataParser.getPagePaths(formConfig);

  getSectionPaths = (formConfig: FormlyFieldConfig[]): SectionPath[] =>
    ConfigDataParser.getSectionPaths(formConfig);

  getQuestionPaths = (formConfig: FormlyFieldConfig[]): QuestionPath[] =>
    ConfigDataParser.getQuestionPaths(formConfig);
}
